export default "__VITE_ASSET__CWDCSCxF__"